import Dialog from '@jetbrains/ring-ui/components/dialog/dialog'
import {memo, useCallback} from 'react'

import type {BuildTypeId, ChangeId} from '../../../../../types'
import {noop} from '../../../../../utils/empty'
import SequenceLoader from '../../../../common/SequenceLoader/SequenceLoader'
import ChangeInfo from '../../ChangeDetailsInfo/ChangeDetailsInfo'
import ChangeFiles from '../../ChangeFiles/ChangeFiles'
import {getChange} from '../../Changes.selectors'

import ChangesDetailsPopupHeader from './ChangesDetailsPopupHeader/ChangesDetailsPopupHeader'

import styles from './ChangeDetailsPopup.css'

import {useAppSelector} from 'src/hooks/react-redux'

type Props = {
  buildTypeId: BuildTypeId | null | undefined
  targetChangeId: ChangeId
  show?: boolean
  cancelDialog?: (id: ChangeId) => unknown
}

function ChangeDetailsPopup({buildTypeId, targetChangeId, show, cancelDialog = noop}: Props) {
  const closeDialog = useCallback(
    () => cancelDialog(targetChangeId),
    [targetChangeId, cancelDialog],
  )
  const {files} = useAppSelector(state => getChange(state, targetChangeId)) ?? {}
  return (
    <div>
      <Dialog
        label="Change"
        className={styles.overlay}
        contentClassName={styles.dialog}
        onCloseAttempt={closeDialog}
        autoFocusFirst={false}
        show={show === true}
        showCloseButton
        trapFocus
      >
        <div className={styles.wrapper}>
          <ChangesDetailsPopupHeader
            className={styles.header}
            buildTypeId={buildTypeId}
            changeId={targetChangeId}
          />
          <div className={styles.content}>
            {files?.count != null && files.count > 0 && targetChangeId != null ? (
              <SequenceLoader>
                <ChangeFiles seqKey="ChangeFiles" changeId={targetChangeId} />
              </SequenceLoader>
            ) : (
              <div className={styles.noFiles}>{'No modified files'}</div>
            )}
          </div>
          <div className={styles.footer}>
            <ChangeInfo changeId={targetChangeId} />
          </div>
        </div>
      </Dialog>
    </div>
  )
}

export default memo(ChangeDetailsPopup)
